import React, { useEffect, useRef, useState } from "react";
import styles from "../styles/Client.module.css";
import { commonStatusFunc, getBackgroundColor } from "../../Common/commondata/commonData";
import PropertyNavbar from "../../PropertyComp/components/PropertyNavbar";
import { clientAction } from "../state/actions";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { Loading } from "../../Common";
import { SomeThingWentWrong } from "../../Common/components/SomeThingWentWrong";
import { Spin } from "antd";
import { EmptyData } from "../../Common/components/EmptyData";

const TransactionDetailComponent = ({
  selectedClient
}) => {
  let screenType = localStorage.getItem("screenType");
  const { documetsClientLoading, currentCLientError, currentCLientDetails } = useSelector((state) => state.client.currentClientReducer);
  const {filterSort} = useSelector((state) => state.PropertyReducer);
  const [pageNumber, setPageNumber] = useState(1);
  const hasMoreDataRef = useRef(true);
  const dispatch = useDispatch();
  const history = useHistory();
  let dataPerPage = 40;
  let unmounted = {
    value: false
  };
  let source = axios.CancelToken.source();
  useEffect(() => {
    if (selectedClient) {
      dispatch(clientAction.getCurrentClient({personId: selectedClient, filterSort, screenType, source, unmounted, hasMoreDataRef, pageNumber, pageSize: dataPerPage}));
    }

    return () => {
      unmounted.value = true;
      source.cancel("Cancelling in cleanup");
    }
  }, [selectedClient, pageNumber, filterSort]);

  useEffect(() => {
    setPageNumber(1);
    hasMoreDataRef.current = false;
  }, [filterSort]);

  const handleClick = (item) => {
    history.push({ pathname: "/transactions", state: { category: item?.isOffer ? "BUYER" : "SELLER", categoryId: item?._id} });
  }

  const handleScroll = (e) => {
    const scrollableDiv = e.target;
    const { scrollTop, scrollHeight, clientHeight } = scrollableDiv;
    const finalScrollHeight = scrollHeight - 20;

    // initially in the 1st page if the data length is less than 20 then do not update the page and return
    if (pageNumber === 1 && currentCLientDetails?.length < dataPerPage) {
      hasMoreDataRef.current = false;
      return;
    }
    // Check if we've reached the bottom of the scrollable container
    if (scrollTop + clientHeight >= finalScrollHeight && !documetsClientLoading && hasMoreDataRef.current) {
      setPageNumber(pageNumber + 1)
    }
  };

  // Add addEventListener for infinite scrollbar
  useEffect(() => {
    const scrollableDiv = document.querySelector(`.${styles.clientContainer}`)
    if (scrollableDiv) {
      scrollableDiv.addEventListener('scroll', handleScroll);
    }

    // Cleanup on unmount
    return () => {
      if (scrollableDiv) {
        scrollableDiv.removeEventListener('scroll', handleScroll);
      }
    };
  }, [documetsClientLoading]);

  return (
    <div style={{width: "100%"}}>
      <PropertyNavbar section={'CONTACT'}/>
      <div className={styles.clientContainer}>
        {
          (documetsClientLoading && (pageNumber <=1)) ? <Loading /> : (
            currentCLientError ? <SomeThingWentWrong subTitle="Something went wrong"/> : (
              currentCLientDetails?.length > 0 ? currentCLientDetails?.map((item, idx)=>{
                const transactionStatus = (item?.isProperty) ? item?.propertyStatus : item?.actualOfferStatus;
                const commonStatus = commonStatusFunc({key: transactionStatus});
                let statusColor = getBackgroundColor({ key: commonStatus?.key });
                let statusBorder = getBackgroundColor({ key: commonStatus?.key, type: "OUTLINE" });
                let statusLabel= getBackgroundColor({ key: commonStatus?.key, type: "TEXT" });
                return <div key={idx} className={styles.clientTransaction} onClick={()=>handleClick(item)}>
                  <div style={{width: "65%"}}>
                    <div className={styles.singleTextWraping}>{item?.address}</div>
                    <div className={styles.datesFont}>Updated:{" "} {moment(item?.updatedAt).format("MM/DD/YYYY hh:mm a")}{" "}</div>
                  </div>
                  <div style={{display: "flex", flexDirection: "column", alignItems: "end", width: "30%"}}>
                    <div style={{display: "flex", gap: "10px", justifyContent: "space-between"}}>
                      <div style={{backgroundColor: statusColor, border: `2px solid ${statusBorder}`}} className={styles.statusLabel}>{statusLabel.value}</div>
                      <div className={item?.isOffer ? styles.clientBuyingCard : styles.clientSellingCard}>{item?.isOffer ? "Buyer Sales" : "Listings"}</div>
                    </div>
                    <div className={styles.datesFont}>{item?.closingDate && !isNaN(Date.parse(item?.closingDate)) && <div>Closing: {moment(item?.closingDate).format("MM/DD/YYYY")}</div>}</div>
                  </div>
                </div>
              }) : <EmptyData />
            )
          )
        }
        {/* Loader for infinite scroll */}
        {documetsClientLoading && pageNumber > 1 && (
          <div style={{ display:"flex", justifyContent:"center", alignItems:"center", height: "10vh" }}>
            <Spin size="medium" />
          </div>
        )}
      </div>
    </div>
  );
};

export default TransactionDetailComponent;
